import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { SessionService } from '../../core/services/session.service';
import { Session } from '../../core/models/session';

@Component({
  selector: 'app-question-answer',
  templateUrl: './question-answer.component.html',
  styleUrls: ['./question-answer.component.css'],
  providers:[SessionService]
})
export class QuestionAnswerComponent implements OnInit {
  @Input() eventId: string;

  @Output() questionAnswerEvent = new EventEmitter<EventQuestionData>();
  
  sessionList: Array<Session> = new Array();
  eventQuestionData = new EventQuestionData();
  name = null;

  constructor(private sessionService: SessionService) { }

  ngOnInit() { 
    this.setSessionList(this.eventId)
    this.eventQuestionData.prop = 'all';
  }
  
  sendSessionId(id = null, name = null) { 
    this.name = name;
    this.eventQuestionData.sessionId = id;
    this.questionAnswerEvent.emit(this.eventQuestionData);
  }

  setSessionList(id) {
    var x = this.sessionService.getSessionList(id)
      x.snapshotChanges().subscribe(list=>{
      //this.contactIdList = new Array();
      this.sessionList = new Array();
      list.forEach(element =>{
        var y = element.payload.toJSON();
        y["$key"] = element.key;
        this.sessionList.push(y as Session);
        console.log(this.sessionList)
      });
    });
  }

}

export class EventQuestionData{
  prop :string;
  sessionId: string;
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/question-answer/question-answer.component.ts